import React from 'react';
import I18n from 'i18n-js';

import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { listingOrdersPath, listingOffersPath } from '@reverbdotcom/commons/src/url_helpers';
import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { EyeIcon, HeartStraightIcon } from '@reverbdotcom/cadence/icons/react';
import { DRAFT } from './toolbarHelpers';

interface IExternalProps {
  listing: Listing;
}

export default function SellerListingInsightStats({
  listing,
}: IExternalProps) {

  if (listing.state === DRAFT) return null;

  const ordersCount = listing.orderStats?.totalOrders ?? 0;
  const offersCount = listing.counts.offers;
  const inBuyerCartsCount = listing.counts.inBuyerCarts;

  const watchersLabelKey = 'discovery.listingsManagement.sellerListingCard.savesLabel';

  return (
    <ul className="d-flex fx-align-center gap-4 pr-4 seller-listing-insight-stats">
      <li className="mobile-d-none">
        <strong>{listing.counts.views}</strong>{' '}
        {I18n.t('discovery.listingsManagement.sellerListingCard.pageViews', {
          count: listing.counts.views,
        })}
      </li>
      <li className="d-none mobile-d-inline">
        <RCTextWithIcon
          icon={<EyeIcon />}
          placement="left"
        >
          {listing.counts.views}
        </RCTextWithIcon>
      </li>

      <li className="mobile-d-none">
        <strong>{listing.counts.watchers}</strong>{' '}
        {I18n.t(watchersLabelKey, {
          count: listing.counts.watchers,
        })}
      </li>
      <li className="d-none mobile-d-inline">
        <RCTextWithIcon
          icon={<HeartStraightIcon />}
          placement="left"
        >
          {listing.counts.watchers}
        </RCTextWithIcon>
      </li>

      {offersCount > 0 && (
        <li className="mobile-d-none">
          <CoreLink
            to={listingOffersPath(listing)}
            className="td-underline fg-color-text-primary"
          >
            <strong>{offersCount}</strong>{' '}
            {I18n.t('discovery.listingsManagement.sellerListingCard.offersLabel', {
              count: offersCount,
            })}
          </CoreLink>
        </li>
      )}

      {inBuyerCartsCount > 0 && (
        <li className="mobile-d-none">
          {I18n.t('discovery.listingsManagement.sellerListingCard.inBuyerCarts', {
            count: listing.counts.inBuyerCarts,
          })}
        </li>
      )}

      {ordersCount > 0 && (
        <li className="mobile-d-none">
          <CoreLink
            to={listingOrdersPath(listing)}
            className="td-underline fg-color-text-primary"
          >
            <strong>{ordersCount}</strong>{' '}
            {I18n.t('discovery.listingsManagement.sellerListingCard.ordersLabel', {
              count: ordersCount,
            })}
          </CoreLink>
        </li>
      )}

      {!!listing.bumpRate?.rate && (
        <li className="mobile-d-none">
          <strong>{listing.bumpRate.rate}%</strong>{' '}
          {I18n.t('discovery.listingsManagement.sellerListingCard.bumpRate')}
        </li>
      )}
    </ul>
  );
}
